<template>
  <b-card title="احراز هویت:">
    <!-- <b-alert :show="errors.length > 0">
      <p v-for="item in errors" v-bind:key="item">{{ item }}</p>
    </b-alert> -->
    
    <b-alert show variant="light" v-if="confMail.status.id == 1520">
    <h4 class="alert-heading">تایید ایمیل!</h4>
    <p>
      ایمیل شما تایید نشده است. لطفا پس از مراجعه به ایمیل خود بر روی لینک ایمیل شده٬ کلیک بفرمایید (پوشه اسپم نیز چک شود)
    </p>
    <!-- <hr> -->
     <b-row align-v="center">
        <b-col cols="12" md="6" sm="12">
          <p class="text-primary">
            * بر روی گزینه ی ارسال کلیک کنید تا پست الکترونیکی حاوی لینک تایید ایمیل برای شما ارسال شود  
            
          </p>
        </b-col>
        <b-col class="" cols="12" md="3" sm="6">
          <b-row>
            <b-col cols="12" md="6">
              <b-button
                block
                variant="warning"
                :class="emailLoading ? 'spinner spinner-light spinner-right' : ''"
                :disabled="emailTimer > 0"
                @click="PrepareEmailValidate()"
              >
                ارسال
                <span v-if="emailTimer > 0">({{ emailTimer }})</span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </b-alert>
  <div v-if="confMail.status.id == 1522">
        <h4 class="mb-5 font-weight-bold text-dark">
          <i class="far fa-check-circle icon-2x text-success"></i>
          تایید ایمیل
        </h4>
        <b-alert variant="success" show>ایمیل شما تایید شده است</b-alert>
      </div>
  <!-- start verify phone -->
    <div class="mb-7">
      <b-form-group label="تلفن ثابت:" label-for="phone">
        <b-form-input
          id="phone"
          v-model="phone"
          :disabled="true"
          placeholder="تلفن ثابت"
        ></b-form-input>
      </b-form-group>
      <div v-if="confPhone.status.id == 1522">
        <h4 class="mb-5 font-weight-bold text-dark">
          <i class="far fa-check-circle icon-2x text-success"></i>
          تایید تلفن ثابت
        </h4>
        <b-alert variant="success" show>تلفن ثابت شما تایید شده است</b-alert>
      </div>

      <b-row v-if="confPhone.status.id == 1520" align-v="center">
        <b-col cols="12" md="6" sm="12">
          <p class="text-primary">
            * بر روی گزینه ی تماس کلیک کنید تا با شما تماس گرفته شود و کد تایید
            برای شما خوانده شود
          </p>
        </b-col>
        <b-col cols="12" md="3" sm="6">
          <b-form-input
            id="phoneCode"
            @keyup="setENChars('')"
            v-model="confirmCode"
            placeholder="کد خوانده شده"
          ></b-form-input>
        </b-col>
        <b-col class="" cols="12" md="3" sm="6">
          <b-row>
            <b-col>
              <b-button
                block
                variant="warning"
                :class="Loading ? 'spinner spinner-light spinner-right' : ''"
                :disabled="timer > 0"
                @click="PrepareValidate()"
              >
                تماس
                <span v-if="timer > 0">({{ timer }})</span>
              </b-button>
            </b-col>
            <b-col>
              <b-button
                block
                variant="primary"
                :class="
                  submitLoading ? 'spinner spinner-light spinner-right' : ''
                "
                @click="Validate(confPhone, confirmCode)"
                class=""
                >تایید</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <!-- end verify phone -->

    <!-- strat verify selfy with nationalcard -->
    <div class="mb-7">
      <div v-if="confSelfiMelli != null && confSelfiMelli.status.id == 1521">
        <h4 class="mb-5 font-weight-bold text-dark">
          <b-icon
            icon="exclamation-circle"
            variant="warning"
            font-scale="1.5"
          ></b-icon>
          منتظر تایید کارت ملی به همراه سلفی
        </h4>
        <b-alert variant="warning" show
          >کارت ملی شما به همراه سلفی در حال تایید توسط مدیریت می باشد</b-alert
        >
      </div>
      <div v-else-if="confSelfiMelli.status.id == 1522">
        <h4 class="mb-10 font-weight-bold text-dark">
          <b-icon
            icon="check-circle"
            variant="success"
            font-scale="1.5"
          ></b-icon>
          تایید کارت ملی به همراه سلفی
        </h4>
        <b-alert variant="success" show
          >کارت ملی شما به همراه سلفی تایید شده است</b-alert
        >
      </div>
      <div v-else-if="confSelfiMelli.status.id == 1520">
        <!-- <p class="text-primary">
          * عکس با کیفیت متوسط از کارت ملی در صورتی که آن را رو به روی خود گرفته
          اید و به صورت سلفی عکس میگیرید را در زیر بارگذاری کنید
        </p> -->
        <h4 class="text-primary pt-2 pb-2">راهنمای گرفتن عکس سلفی:</h4>
        <b-card
          img-src="https://shepa.com/wp-content/uploads/2023/02/4000-scaled.jpg"
          img-alt="Card image"
          img-right
          img-width="300px"
          class="mb-3"
        >
          <ul>
            <li>
              در نظر داشته باشید شما می‌بایست متن راستی‌آزمایی زیر را بر روی
              کاغذ با دست خط خود نوشته و یا چاپ کرده و اطلاعات آن را تکمیل کنید.
            </li>
            <li>تصویر سلفی باید شامل متن دست‌نویس و کارت شناسایی باشد.</li>
            <li>خواهشمند است از پوشش مناسب استفاده فرمایید.</li>
            <li>
              تصویر سلفی خود را در محیط و نور مناسب تهیه نمایید، پشت تصویر حتما
              باید روشن باشد.
            </li>
            <li>
              گردی صورت باید کاملا مشخص باشد و با چیزی پوشانده نشود.(ماسک و عینک
              آفتابی و.....).
            </li>
            <li>خواهشمند است از اضافه یا کم کردن لغات خودداری نمایید.</li>
          </ul>
        </b-card>
        <h4 class="text-primary pt-2 pb-2">متن تصویر سلفی:</h4>
        <b-card class="mb-3">
          قوانین وب سایت شپا مورد تایید اینجانب {{ user.fa_name }} {{ user.fa_family }} با کد ملی
          {{ user.national_card_number }} می باشد و به منظور احراز هویت، تصویر کارت ملی
          پیوست ارسال می شود.
          <br />
          نام و نام خانوادگی: {{ user.fa_name }} {{ user.fa_family }}
          <br />
          تاریخ:{{ user.date }}
          <br />
          امضا
        </b-card>
        <h4 class="text-primary pt-2 pb-2">بارگذاری تصویر سلفی:</h4>
        <b-row>
          <b-col cols="12" md="9" sm="6">
            <FileUploader v-model="confirmCodeSelfi"></FileUploader>
          </b-col>
          <b-col cols="12" md="3" sm="6">
            <b-button
              variant="primary"
              @click="Validate(confSelfiMelli, confirmCodeSelfi)"
              block
              >ذخیره عکس</b-button
            >
          </b-col>
        </b-row>
        <b-row class="mb-3 mt-3">
          <b-col>
            <b-img
              :src="'https://api.shepa.com/api/file/' + confirmCodeSelfi"
              fluid
            ></b-img>
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
    </div>
    <!-- end verify selfy with nationalcard -->

    <!-- start verify nationalcard  -->
    <div class="mb-7">
      <div v-if="confCardMelli.status.id == 1520">
        <h4 class="text-primary pt-2 pb-2">بارگذاری اسکن کارت ملی:</h4>
        <b-row>
          <b-col cols="12" md="9" sm="6">
            <FileUploader v-model="confirmCodeMelli"></FileUploader>
          </b-col>
          <b-col cols="12" md="3" sm="6">
            <b-button
              block
              variant="primary"
              @click="Validate(confCardMelli, confirmCodeMelli)"
              >ذخیره عکس</b-button
            >
          </b-col>
        </b-row>
        <b-row class="mb-3 mt-3">
          <b-col>
            <b-img
              :src="'https://api.shepa.com/api/file/' + confirmCodeMelli"
              fluid
            ></b-img>
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <div v-if="confCardMelli.status.id == 1521">
        <h4 class="mb-5 font-weight-bold text-dark">
          <b-icon
            icon="exclamation-circle"
            variant="warning"
            font-scale="1.5"
          ></b-icon>
          منتظر تایید کارت ملی
        </h4>
        <b-alert variant="warning" show
          >کارت ملی شما در حال تایید توسط مدیریت می باشد</b-alert
        >
      </div>
      <div v-if="confCardMelli.status.id == 1522">
        <h4 class="mb-5 font-weight-bold text-dark">
          <b-icon
            icon="check-circle"
            variant="success"
            font-scale="1.5"
          ></b-icon>
          تایید کارت ملی به همراه سلفی
        </h4>
        <b-alert variant="success" show>کارت ملی شما تایید شده است</b-alert>
      </div>
    </div>
    <!-- start verify nationalcard  -->
    <!-- start verify work lisence  -->
    <div>
      <div v-if="licenseWork.status.id == 1520">
        <p>اسکن مجوز کسب و کار خود را در زیر بارگذاری نمایید</p>
        <b-row>
          <b-col md="8" sm="6" cols="12">
            <FileUploader v-model="confirmCodeWork"></FileUploader>
          </b-col>
          <b-col md="4" sm="6" cols="12">
            <b-button
              variant="primary"
              @click="Validate(licenseWork, confirmCodeWork)"
              class="ml-3"
              >ذخیره عکس</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-img
              :src="'https://api.shepa.com/api/file/' + confirmCode"
              fluid
            ></b-img>
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <div v-if="licenseWork.status.id == 1521">
        <h4 class="mb-5 font-weight-bold text-dark">
          <b-icon
            icon="exclamation-circle"
            variant="warning"
            font-scale="1.5"
          ></b-icon>
          منتظر تایید مجوز کسب و کار
        </h4>
        <b-alert variant="warning" show
          >مجوز کسب و کار شما در حال تایید توسط مدیریت می باشد</b-alert
        >
      </div>
      <div v-if="licenseWork.status.id == 1522">
        <h4 class="mb-5 font-weight-bold text-dark">
          <b-icon
            icon="check-circle"
            variant="success"
            font-scale="1.5"
          ></b-icon>
          تایید مجوز کسب و کار
        </h4>
        <b-alert variant="success" show
          >مجوز کسب و کار شما تایید شده است</b-alert
        >
      </div>
    </div>
    <!-- end verify work lisence  -->
    <b-row>
      <b-col>
        <button
          class="btn btn-primary"
          @click="
            $router.push({
              name: 'dashboard',
              query: { from: 'authentication' },
            })
          "
        >
          بازگشت به صفحه اصلی
        </button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
import FileUploader from "../../components/fileUploader";
import persianDate from "../../helpers/persianDate";
// import { GETUSER } from "@/core/services/store/getUser.module";
// import sessionHelper from "../../helpers/sessionHelper.js";

export default {
  name: "ConfirmationDetails",
  data: function () {
    return {
      item: { type: {} },
      mobile: "",
      confirmCode: "",
      confirmCodeMelli: "",
      confirmCodeSelfi: "",
      confirmCodeWork: "",
      confirmCodeEmail: "",
      email: "",
      phone: "",
      address: "",
      timer: 0,
      emailTimer: 0,
      timeInterval: "",
      Loading: false,
      emailLoading: false,
      submitLoading: false,
      btn_disable: false,
      errors: [],
      confPhone: { status: { id: null } },
      refreshConfData: null,
      confCardMelli: { status: { id: null } },
      confSelfiMelli: { status: { id: null } },
      licenseWork: { status: { id: null } },
      user: { name: null, fa_name:null, fa_family:null, date: null, national_card_number: null },
      confMail: {status : { id: null }}
    };
  },
  components: {
    FileUploader,
  },
  watch: {
    // confPhone: function (newVal, oldVal) {
    //   this.item = newVal;
    // },
    // dataUpdated: function (newVal, oldVal) {
    //   this.mobile = "";
    //   this.email = "";
    //   this.phone = "";
    //   this.refreshDatas();
    // },
  },
  created() {
    this.afterverified();
  },
  methods: {
    setCollectTimeOut() {
      this.btn_disable = false;
      this.afterverified();
      this.timer = 0;
    },
    PrepareEmailValidate() {
      if (this.emailTimer > 0) {
        return;
      }
      this.emailLoading = true;
      httpHelper.postData("userconf/prepare", this.confMail).then((res) => {
        this.emailTimer = 120;
        this.CalcEmailTime();
        this.emailLoading = false;
      });
    },
    PrepareValidate() {
      if (this.timer > 0) {
        return;
      }
      this.Loading = true;
      httpHelper.postData("userconf/prepare", this.confPhone).then((res) => {
        this.timer = 120;
        this.CalcTime();
        this.Loading = false;
      });
    },
    setENChars(field) {
      this.confirmCode = this.confirmCode.toEnDigits();
    },
    Validate(item, confirmCode) {
      Object.assign(item, { confirmCode: confirmCode });
      this.errors = [];
      if (confirmCode != "") {
        httpHelper.postData("userconf/validate", item).then((res) => {
          this.submitLoading = false;
          if (res.success) {
            if (res.result == true) {
              if (this.item.mdid6_type == 1502) {
                this.btn_disable = true;
                this.errors.push("ایمیل تایید برای شما ارسال گردید");
              }
              if (this.item.mdid6_type == 1503) {
                setTimeout(() => this.setCollectTimeOut(), 9000);
              }
            } else {
              this.errors.push("کد وارد شده صحیح نمی باشد");
            }
            this.afterverified();
          }
        });
      } else {
        this.$makeToast("danger", "بارگذاری", "عکسی انتخاب نشده است.", 7000);
      }
    },
    CalcTime() {
      this.timeInterval = setInterval(() => {
        this.timer--;
        if (this.timer == 0) {
          clearInterval(this.timeInterval);
        }
      }, 1000);
    },
    CalcEmailTime() {
      this.timeInterval = setInterval(() => {
        this.emailTimer--;
        if (this.emailTimer == 0) {
          clearInterval(this.timeInterval);
        }
      }, 1000);
    },
    refreshDatas() {
      httpHelper.getData("users/verify").then((res) => {
        console.log("res:", res);
        Object.assign(this.user, {
          name: res.name,
          fa_name: res.fa_name,
          fa_family: res.fa_family,
          date: persianDate.getDateByFormat(new Date()),
          national_card_number: res.national_card_number,
        });
        this.mobile = res.mobile;
        this.email = res.email;
        this.phone = res.pre_phone + "-" + res.phone;
      });
    },
    afterverified() {
      httpHelper.setAuth();
      httpHelper
        .getData("userconf")
        .then((res) => {
          this.userConf = res.result;
          this.userConf.forEach((element) => {
            if (element.type.id == 1501) {
              this.confMobile = element;
            } else if (element.type.id == 1503) {
              this.confPhone = element;
            } else if (element.type.id == 1506) {
              this.confCardMelli = element;
            } else if (element.type.id == 1505) {
              this.confSelfiMelli = element;
            } else if (element.type.id == 1736) {
              this.licenseWork = element;
            } else if (element.type.id == 1502) {
              this.confMail = element;
            }
          });
        })
        .finally(() => {});
    },
    // backToDashboard(){
    //   this.$store.dispatch(GETUSER).then((data)=>{
    //     sessionHelper.setUser(data);
    //   }).finally(()=>{
    //     this.$router.push({name:'dashboard'});
    //   });
    // }
  },
  mounted() {
    this.refreshDatas();
  },
};
</script>
<style>
.form-control.is-invalid,
.was-validated .form-control:invalid {
  padding-right: calc(1.5em + 1.3rem);
}
.form-control.is-valid,
.was-validated .form-control:valid {
  padding-right: calc(1.5em + 1.3rem);
}
.custom-select.is-valid,
.was-validated .custom-select:valid {
  padding-right: calc(1.5em + 1.3rem);
}
</style>
